
import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';

export const teams = createApi({
    reducerPath: 'teams',
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ['teams'],
    endpoints: (builder) => ({

        getteams: builder.query({
            query: ({ search }) => `/api/team/get-users`,
            providesTags: ['teams'],
        }),

        createteams: builder.mutation({
            query: (data) => ({
                url: `/api/team/add-user`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['teams'],
        }),

        deleteteams: builder.mutation({
            query: (id) => ({
                url: `/api/team/delete-user/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['teams'],
        }),


        updateteams: builder.mutation({
            query: (data) => ({
                url: `/api/team/update-user`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['teams'],
        }),
    }),
});

export const {
    useGetteamsQuery,
    useCreateteamsMutation,
    useDeleteteamsMutation,
    useUpdateteamsMutation
} = teams;